// Prices shown on the marketing site. They must mirror the prices each product app shows itself:
// Write: app.author-pro.com Settings > Billing. Review: draft.author-pro.com/pricing.
export const BOOKING_URL = "https://meetings.series-a.co/meetings/series-a/authorpro";

export type PricingPlan = {
  id: "write" | "review" | "extend";
  stage: string;
  name: string;
  price: string;
  priceNote: string;
  summary: string;
  features: string[];
  cta: { label: string; href: string };
};

export const PRICING_PLANS: PricingPlan[] = [
  {
    id: "write",
    stage: "Write",
    name: "Write Your Book",
    price: "$99",
    priceNote: "per month",
    summary: "The guided Write platform: from your idea to a concept, an outline and finished chapters.",
    features: [
      "Author profile and discovery",
      "Concept and chapter-by-chapter outline",
      "AI-assisted chapter writing",
      "Review and export",
    ],
    cta: { label: "Start Your Book Today", href: "/sign-in" },
  },
  {
    id: "review",
    stage: "Review",
    name: "Manuscript Review",
    price: "$99",
    priceNote: "one-time, per manuscript",
    summary: "Upload a draft to FirstDraft. Start with a free preview, then unlock the complete review.",
    features: [
      "Free preview before you pay",
      "Structure, flow and sentence-level passes",
      "Based on Robin Colucci's bestselling framework",
      "Word and PDF feedback reports",
    ],
    cta: { label: "See review pricing", href: "https://draft.author-pro.com/pricing" },
  },
  {
    id: "extend",
    stage: "Extend",
    name: "Extend",
    price: "Custom",
    priceNote: "scoped on a call",
    summary: "Turn a published book into an interactive platform with assessments and personalised reports.",
    features: [
      "Reader assessment built from your book",
      "Personalised reports for every reader",
      "Programme recommendations that lead to you",
      "Built and launched with our team",
    ],
    cta: { label: "Book a Call", href: BOOKING_URL },
  },
];
